import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import navbarImg from "../assets/navbarimg.png";

const NavBar = () => {
  const [nav, setNav] = useState(false);

  const links = [
    { id: 1, link: "home" },
    { id: 2, link: "about" },
    { id: 3, link: "portfolio" },
    { id: 4, link: "experience" },
    // { id: 5, link: "contact" },
  ];

  const scrollToSection = (id) => {
    setNav(false);
    const element = document.getElementById(id);
    if (element) {
      // Get the element's top relative to the document
      const navBarHeight = 80; // Adjust this if your navbar height changes
      const y =
        element.getBoundingClientRect().top + window.pageYOffset - navBarHeight;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <div className="fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#0a192f] text-gray-300">
      <div>
        <img src={navbarImg} alt="Logo" style={{ width: "65px" }} />
      </div>

      {/* Desktop Links */}
      <ul className="hidden md:flex">
        {links.map(({ id, link }) => (
          <li
            key={id}
            onClick={() => scrollToSection(link)}
            className="px-4 cursor-pointer capitalize font-medium text-gray-500 hover:scale-105 duration-200"
          >
            {link}
          </li>
        ))}
      </ul>

      {/* Mobile Menu Icon */}
      <div
        onClick={() => setNav(!nav)}
        className="cursor-pointer pr-4 z-10 text-gray-500 md:hidden"
      >
        {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
      </div>

      {/* Mobile Menu */}
      {nav && (
        <ul className="flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-[#0a192f] text-gray-500">
          {links.map(({ id, link }) => (
            <li
              key={id}
              onClick={() => scrollToSection(link)}
              className="px-4 cursor-pointer capitalize py-6 text-4xl"
            >
              {link}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NavBar;